import React from 'react';
import Icon from './Icon';
import StatCounter from './StatCounter';
import './Hero.css';

export default function Hero() {
  return (
    <section id="top" className="hero">
      <div className="hero__blob hero__blob--teal" />
      <div className="hero__blob hero__blob--amber" />

      <div className="container hero__inner">
        <div className="hero__copy">
          <span className="eyebrow eyebrow--light">
            <Icon name="mapPin" size={14} />
            Built in Ghana, for Ghana
          </span>
          <h1 className="hero__title">
            Your Ride, <span className="hero__title-accent">Your Delivery</span>, Your Way.
          </h1>
          <p className="hero__desc">
            BikesDrop is Ghana&rsquo;s all-in-one delivery &amp; logistics platform, connecting{' '}
            <strong>customers</strong>, <strong>riders</strong> and <strong>merchants</strong> on one
            trusted network. Send a package, move cargo, run a campus errand, restock a store, or earn
            as a rider, all from a single app.
          </p>

          <div className="hero__actions">
            <a href="#apps" className="btn btn--teal">
              Explore Our Apps
            </a>
            <a href="#invest" className="btn btn--ghost">
              Partner With Us
            </a>
          </div>

          <div className="hero__stats">
            <div className="hero__stat">
              <StatCounter value={2} />
              <span>Apps, One Platform</span>
            </div>
            <div className="hero__stat">
              <StatCounter value={7} suffix="+" />
              <span>On-demand Services</span>
            </div>
            <div className="hero__stat">
              <strong>24/7</strong>
              <span>Riders Ready to Move</span>
            </div>
          </div>
        </div>

        <div className="hero__visual">
          <div className="hero__ring">
            <img src="/assets/bikesdrop/pickup_delivery.jpg" alt="BikesDrop rider on a delivery bike" />
          </div>
          <div className="hero__floating hero__floating--top">
            <span className="hero__floating-dot" />
            Live tracking, every trip
          </div>
          <div className="hero__floating hero__floating--bottom">
            <Icon name="compass" size={14} />
            Real riders. Real routes. Real time.
          </div>
        </div>
      </div>
    </section>
  );
}
